import { useEffect, useState } from "react";
import Player, { type ReactPlayerProps } from "react-player";

export function ReactPlayerThrowsOnError(props: ReactPlayerProps) {
  const [error, setError] = useState<Error>();

  useEffect(function effectResetErrorOnUnmount() {
    return () => {
      setError(undefined);
    };
  }, []);

  if (error) {
    throw error;
  }

  return (
    <Player
      {...props}
      onError={(error) => {
        try {
          setError(new Error(JSON.stringify(error)));
        } catch {
          setError(new Error(error?.message ?? "React Player Error"));
        }
      }}
    />
  );
}
